var map = {
	"./awaiting_delivery-icon.svg": 41196,
	"./awaiting_store_confirmation-icon.svg": 87219,
	"./canceled-icon.svg": 39982,
	"./closed-icon.svg": 23993,
	"./delivered-icon.svg": 91855,
	"./in_return-icon.svg": 76665,
	"./in_return_courier-icon.svg": 75085,
	"./in_source_preparation-icon.svg": 79480,
	"./in_transit-icon.svg": 87710,
	"./pending_package-icon.svg": 64555,
	"./pickup-icon.svg": 96365,
	"./ready_for_pickup-icon.svg": 721,
	"./rescheduled-icon.svg": 89783,
	"./return_in_review-icon.svg": 53308,
	"./returned-icon.svg": 4826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9;